import styled from "styled-components";

import { ButtonWrapper } from "ds/Button";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  height: 100%;
`;

export const Drawer = styled.div`
  background-color: var(--section-snow-background-color, var(--snow));
  width: 356px;
  padding: 16px 40px 40px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const Content = styled.div`
  background-color: var(
    --section-color-neutral-300-background-color,
    var(--color-neutral-300)
  );
  flex: 1;
  padding: 32px 40px 9px 40px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const Separator = styled.div`
  min-height: 1px;
  background-color: var(--section-stone-border-color, var(--stone));
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const Footer = styled(ButtonWrapper)`
  margin-top: auto;
  padding-top: 32px;
`;

export const Block = styled.div``;
